<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR PROGRAMA SOCIAL' : 'NOVO PROGRAMA SOCIAL'" titleIcon="fas fa-hands-helping">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: Bolsa Família"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Esfera" prop="esfera" :rules="$requiredChange">
                            <el-select v-model="dados.esfera" style="width: 100%;">
                                <el-option v-for="e in esferas" :key="e" :value="e" :label="rotulo(e)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Órgão gestor">
                            <el-input v-model="dados.orgao_gestor" placeholder="MDS"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Condiciona o benefício à frequência escolar?">
                            <el-switch v-model="dados.exige_frequencia_minima" active-text="Sim" inactive-text="Não"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="dados.exige_frequencia_minima" :xs="24" :sm="12">
                        <el-form-item label="Frequência mínima (%)">
                            <el-input-number v-model="dados.frequencia_minima" :min="1" :max="100" :precision="2"
                                controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Descrição">
                    <el-input v-model="dados.descricao" type="textarea" :rows="3"></el-input>
                </el-form-item>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/programa-social"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 36. */
export default {
    data: () => ({
        esferas: ['federal', 'estadual', 'municipal'],
        dados: { nome: '', esfera: '', orgao_gestor: '', exige_frequencia_minima: false,
                 frequencia_minima: null, descricao: '', situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/programa-social/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/programa-social')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        rotulo (v) { return { federal: 'Federal', estadual: 'Estadual', municipal: 'Municipal' }[v] || v },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/programa-social/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/programa-social/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Programa social salvo.', type: 'success' })
                    this.$router.push('/admin/programa-social')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
